import { RoadblockHandler } from '@platforms/shared';
import { TemplateAction, TemplateRegistry } from '@wikia/ad-engine';
import { Observable } from 'rxjs';

// eslint-disable-next-line no-restricted-imports
import { isRoadblockV2Enabled } from '../../../core/utils/condition/roadblock-slots-visibility';

export function registerRoadblockTemplate(registry: TemplateRegistry): Observable<TemplateAction> {
	const roadblockHandler = isRoadblockV2Enabled()
		? RoadblockHandler.config({
				enabledSlots: [
					'top_boxad',
					'fandom_dt_galleries',
					'gallery_leaderboard',
					'incontent_boxad',
					'bottom_leaderboard',
					'floor_adhesion',
				],
				disableSlots: ['incontent_player', 'featured', 'incontent_leaderboard'],
			})
		: RoadblockHandler.config({
				enabledSlots: ['top_boxad', 'fandom_dt_galleries', 'gallery_leaderboard'],
				disableSlots: ['floor_adhesion'],
			});

	return registry.register(
		'roadblock',
		{
			initial: [RoadblockHandler],
		},
		'initial',
		[roadblockHandler],
	);
}
